import React from "react";
import { Form } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const UIPhone = ({ label, name, required, rules, onChange, onBlur, disabled, defaultValue, tooltip, style = {}, compact = false}) => {
  
  const handleChange = (value, country, e, formattedValue) => {
    onChange && onChange(value, country, e, formattedValue); 
  }

  return (
    <Form.Item
      label={
        <span style={{ fontSize: compact ? "14px" : "16px", fontWeight: "500" }}>{label}</span>
      }
      name={name}
      required={required}
      rules={rules}
      initialValue={defaultValue}
      tooltip={tooltip && {
        title: tooltip,
        icon: <InfoCircleOutlined />,
      }}
    >
      <PhoneInput
        placeholder=""
        country="pk"
        onChange={handleChange} 
        onBlur={onBlur}
        disabled={disabled}
        style={style}
        inputStyle={{
          height: compact ? "42px" : "50px", 
          width: "100%",  
          fontSize: compact ? "14px" : "16px", 
          padding: "0 50px", 
          borderRadius: compact ? "22px" : undefined,
          border: compact ? "1px solid #e5e7eb" : undefined,
          boxShadow: compact ? "0 8px 22px rgba(15, 23, 42, 0.04)" : undefined,
        }}
        buttonStyle={{
          height: compact ? "42px" : "50px", 
          borderRadius: compact ? "22px 0 0 22px" : undefined,
        }}
        dropdownStyle={{
          fontSize: "20px", 
        }}
      />
    </Form.Item>
  );
}

export default UIPhone;
